
import { Vue } from "vue-class-component";

export default class Misroute extends Vue {}
